// Adapted from D:/AI/site-thebutler/src/router/config.tsx
import type { RouteRecord } from 'vite-react-ssg';
import routesData from '@/data/routes.json';
import type { RouteManifest } from '@/data/types';
import { NotFound } from '@/components/NotFound';
import { Page } from '@/components/Page';
import { SiteLayout } from '@/components/layout/SiteLayout';
import { shopRoutes } from './shopData';
import { withLang } from '@/lib/lang';

const fixedRoutes = (routesData as RouteManifest).routes;
const renderRoutes = [...fixedRoutes, ...shopRoutes];

const pageRoutes: RouteRecord[] = renderRoutes.map((route) => ({
  path: route.url,
  element: <Page />,
  getStaticPaths: () => [route.url],
}));
// 英語ページ: 各 url に /en を前置した同形ルート(docs/_prompts/20260917_en_site_spec.md §2-3)
const pageRoutesEn: RouteRecord[] = renderRoutes.map((route) => ({
  path: withLang(route.url, 'en'),
  element: <Page />,
  getStaticPaths: () => [withLang(route.url, 'en')],
}));

const routes: RouteRecord[] = [
  {
    element: <SiteLayout />,
    children: [
      ...pageRoutes,
      ...pageRoutesEn,
      { path: '*', element: <NotFound /> },
      { path: '/404/', element: <NotFound /> },
      { path: '/en/404/', element: <NotFound /> },
    ],
  },
];

export default routes;
